import type { DriverPerformanceTier } from '../enums/DriverPerformanceTier'

export class DriverPerformanceEntity {
  completedShipments?: number | null
  averageCompletedShipmentsPerDay?: number | null
  averageDeliveryTime?: number | null
  driverScore?: number | null
  acceptedAssignmentsCount?: number | null
  assignmentsCount?: number | null
  activeHours?: number | null
  totalDriverShift?: number | null
  inShiftActiveHours?: number | null
  deliveryTimeScore?: number | null
  customerRatingScore?: number | null
  shiftAdherenceScore?: number | null
  acceptanceRateScore?: number | null
  activeHoursScore?: number | null
  weightedDeliveryTimeScore?: number | null
  weightedCustomerRatingScore?: number | null
  weightedShiftAdherenceScore?: number | null
  weightedAcceptanceRateScore?: number | null
  weightedActiveHoursScore?: number | null
  finalScore?: number | null
  performanceTier?: DriverPerformanceTier | null
}
